import React, {FC} from 'react';
import styled from 'styled-components';

import {CardModel} from '../../../models/api/cardModel';
import {VisualContactModel} from '../../../models/api/visualContactModel';
import {useContactDetailsContext} from '../contactDetailsContext';
import {ContactHeaderNameAndAvatar} from './contactHeaderDetails';
import {ContactHeaderGroupsContainer} from './contactHeaderGroupsContainer';
import {ContactHeaderVisibilityIndicatorContainer} from './contactHeaderVisibilityIndicatorContainer';

/*
 * Props.
 */

interface ContactHeaderProps {
  contact?: VisualContactModel;
  card?: CardModel;
}

/*
 * Styles.
 */

const StyledContactHeaderContainerDiv = styled.div`
  padding: 16px;
`;

export const ContactHeader: FC<ContactHeaderProps> = (props) => {
  const {contact, card} = props;
  const {panelId} = useContactDetailsContext();

  return (
    <StyledContactHeaderContainerDiv>
      <ContactHeaderNameAndAvatar contact={contact} card={card} />
      <ContactHeaderVisibilityIndicatorContainer panelId={panelId} card={card} contact={contact} />
      {card && <ContactHeaderGroupsContainer card={card} />}
    </StyledContactHeaderContainerDiv>
  );
};
